import { render, staticRenderFns } from "./StreamItemHeader.vue?vue&type=template&id=4b9c3c80"
import script from "./StreamItemHeader.vue?vue&type=script&lang=js"
export * from "./StreamItemHeader.vue?vue&type=script&lang=js"
import style0 from "./StreamItemHeader.vue?vue&type=style&index=0&id=4b9c3c80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports